import { Pipe } from '@angular/core';
var SearchPipe = (function () {
    function SearchPipe() {
    }
    SearchPipe.prototype.transform = function (items, keys, attribute) {
        var _this = this;
        if (!items)
            return [];
        if (!keys)
            return items;
        keys = this.normalize(keys);
        var splited = keys.split(' ');
        return items.filter(function (it) {
            var contains = true;
            splited.forEach(function (s) {
                s = s.trim();
                if (s != '' && contains)
                    contains = _this.normalize(it[attribute]).includes(s);
            });
            return contains;
        });
    };
    SearchPipe.prototype.normalize = function (s) {
        var map = { "â": "a", "Â": "A", "à": "a", "À": "A", "á": "a", "Á": "A", "ã": "a", "Ã": "A", "ê": "e", "Ê": "E", "è": "e", "È": "E", "é": "e", "É": "E", "î": "i", "Î": "I", "ì": "i", "Ì": "I", "í": "i", "Í": "I", "õ": "o", "Õ": "O", "ô": "o", "Ô": "O", "ò": "o", "Ò": "O", "ó": "o", "Ó": "O", "ü": "u", "Ü": "U", "û": "u", "Û": "U", "ú": "u", "Ú": "U", "ù": "u", "Ù": "U", "ç": "c", "Ç": "C" };
        s = s.toLowerCase();
        s = s.replace(/[\W\[\] ]/g, function (a) { return map[a] || a; });
        return s;
    };
    ;
    SearchPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'search',
                },] },
    ];
    /** @nocollapse */
    SearchPipe.ctorParameters = function () { return []; };
    return SearchPipe;
}());
export { SearchPipe };
//# sourceMappingURL=search.js.map


//////////////////
// WEBPACK FOOTER
// ../ionic-commons/dist/pipes/search.js
// module id = 517
// module chunks = 0